import { withPrefix } from 'gatsby';
import React from 'react';

import styles from './Logo.styles';

const Logo = ({ logo, logoLink }) => (
  <a href={logoLink} target="_blank" css={styles}>
    <img src={withPrefix(logo)} alt="logo" />
  </a>
);

export default Logo;
